import type {PermissionsRecordType} from '../permissions';

export const multiFactorPermissions = {
  canReadTenantMultiFactorAuthenticationSettings: {
    actionId: 'ACTIVATE',
    resourceId: 'MULTI_FACTOR_AUTHENTICATION_SETTINGS',
    scopes: [],
  },
  canReadUserMultiFactorAuthenticationSettings: {
    actionId: 'READ_CURRENT',
    resourceId: 'USER_MULTI_FACTOR_AUTHENTICATION',
    scopes: [],
  },
} satisfies PermissionsRecordType;
